import React, { useEffect } from "react";
import { useState } from "react";
import { MdHome } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";

const Nav = ({ links, children }) => {
  const location = useLocation();
  const [homeLink, setHomeLink] = useState("#");

  useEffect(() => {
    setHomeLink("/" + location.pathname.split("/")[1] + "/dashboard");
  }, [location]);

  return (
    <div className="nav">
      <div>
        <Link to={homeLink}>
          <MdHome /> &nbsp;
        </Link>
        {links.map((elt, key) => {
          if (key === links.length - 1) {
            return (
              <span key={key} className="next">{`${key !== 0 ? " / " : ""}${
                elt.linkname
              }`}</span>
            );
          } else {
            return (
              <Link key={key} to={`${elt.href}`}>{`${key !== 0 ? " / " : ""} ${
                elt.linkname
              }`}</Link>
            );
          }
        })}
      </div>
      <div>{children}</div>
    </div>
  );
};

export default Nav;
